/**
 * Configuraciones por temporada que se heredan: si la temporada pedida no
 * tiene filas guardadas, se usan las de la temporada anterior más reciente.
 * Lo que se guarda después queda como propio de la temporada pedida.
 *
 * Se toma la temporada completa (no tipo por tipo) para no mezclar valores de
 * temporadas distintas en una misma configuración.
 */
export const pickLatestSeasonRows = <T extends { season: string | null }>(
  rows: T[],
  season: string
): { rows: T[]; season: string | null } => {
  const latest = rows
    .map((row) => row.season)
    .filter((s): s is string => !!s && s <= season)
    .sort()
    .pop();

  if (!latest) return { rows: [], season: null };
  return { rows: rows.filter((row) => row.season === latest), season: latest };
};

/** La temporada de origen si es otra, o null si los datos son de `season`. */
export const inheritedFromSeason = (
  sourceSeason: string | null,
  season: string
): string | null => (sourceSeason && sourceSeason !== season ? sourceSeason : null);
